import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { MROReviewedCart } from "@cart-client/interfaces/MROFoodCart";
import { CroutonIds } from "@swiggy-private/cart-types";
import { isMROFlow } from "@swiggy-private/checkout-core";
import { setTimerWidgetClosingTime, clearTimerFromStorage } from "@swiggy-private/core-ui";

const getRxClosingCroutonEndTimestampSec = (cartResponse: MROReviewedCart | ReviewedCart | null): number => {
    const rxCrouton = cartResponse?.data?.croutonList?.find((crouton) => crouton.type === CroutonIds.RX_CLOSING_TIMER);
    return Number(rxCrouton?.data?.endTimestamp ?? 0);
};

const getMroRxClosingTimeInMs = (cartResponse: MROReviewedCart | ReviewedCart | null): number => {
    const endTimestampSec = getRxClosingCroutonEndTimestampSec(cartResponse);
    if (endTimestampSec <= 0 || endTimestampSec * 1000 <= Date.now()) {
        return 0;
    }
    return Math.round(endTimestampSec * 1000 - Date.now());
};

export const getClosingTimeInMs = (cartResponse: MROReviewedCart | ReviewedCart | null): number => {
    if (isMROFlow()) {
        return getMroRxClosingTimeInMs(cartResponse);
    }
    return Number(cartResponse?.data?.restaurant_details?.closing_in_ms ?? 0);
};

export const isClosingTimeAvailable = (cartResponse: MROReviewedCart | ReviewedCart | null): boolean => {
    const closingInMs = getClosingTimeInMs(cartResponse);
    return closingInMs !== 0;
};

export const setClosingTimeInStorage = (cartResponse: MROReviewedCart | ReviewedCart | null): void => {
    if (isClosingTimeAvailable(cartResponse)) {
        const durationInSeconds = getClosingTimeFromApiInSeconds(cartResponse);
        const closeTime = isMROFlow()
            ? getRxClosingCroutonEndTimestampSec(cartResponse) * 1000
            : Date.now() + getClosingTimeInMs(cartResponse);
        setTimerWidgetClosingTime(closeTime, durationInSeconds);
    } else {
        clearTimerFromStorage();
    }
};

export const getClosingTimeFromApiInSeconds = (cartResponse: MROReviewedCart | ReviewedCart | null): number => {
    const closingInMs = getClosingTimeInMs(cartResponse);
    return Math.round(closingInMs / 1000);
};
